export const AUTH_BASE_URL = 'auth';

export const AUTH_API_URL = `${process.env.NX_SERVER_URL}auth`;

export const authQueryKeys = {
  base: () => [AUTH_BASE_URL],
  google: {
    base: () => [...authQueryKeys.base(), 'google'],
    enabled: () => [...authQueryKeys.google.base(), 'enabled'],
  },
};
